import {
  countLandscapeItems,
  isFallbackWidePhoto,
  shouldSpanWide,
} from './mediaGridLayout';
import type { MediaItem } from './types';
import { useImageRatios } from './useImageRatios';

const INITIAL_MEASUREMENT_LIMIT = 20;

export function useMediaGrid(
  items: Readonly<Ref<MediaItem[]>>,
  columns: Readonly<Ref<number>>,
  isShortGallery: Readonly<Ref<boolean>>,
) {
  const { ratioMap } = useImageRatios(items);

  const landscapeShare = computed(() => {
    if (!items.value.length) {
      return 0;
    }

    const count = countLandscapeItems(items.value, ratioMap.value);
    return count / items.value.length;
  });

  const isGridReady = computed(() => {
    const initialItems = items.value.slice(0, INITIAL_MEASUREMENT_LIMIT);

    return initialItems.every(
      (item) => !item.src || ratioMap.value.has(item.id),
    );
  });

  function shouldItemSpanWide(item: MediaItem, index: number): boolean {
    if (isShortGallery.value) {
      return false;
    }

    const ratio = ratioMap.value.get(item.id);
    if (ratio === undefined) {
      return isFallbackWidePhoto(index);
    }

    return shouldSpanWide(ratio, index, columns.value, landscapeShare.value);
  }

  const layoutItems = computed(() =>
    items.value.map((item, index) => ({
      item,
      index,
      isWide: shouldItemSpanWide(item, index),
      ratio: ratioMap.value.get(item.id),
    })),
  );

  return { isGridReady, layoutItems };
}
